/**
 * Created by jv on 13/02/2017.
 */
const utils = require("Sources/utils/utils");
const LanguageManager = require("Sources/services/languagemanager");
const moment = require("moment");
const ElementCreator = require("Sources/components/element-creator");

var template = {};

(function(Template)
{
  Template.createTableHeader = function(data, options)
  {
    options = utils.isNotNull(options) ? options : {};
    options.cellClasses = utils.isArray(options.cellClasses) ? options.cellClasses : [ "fo-cell", "header" ];
    options.rowClasses = utils.isArray(options.rowClasses) ? options.rowClasses : [ "fo-row" ];

    var cellElements = "";

    for(var i = 0; i < data.length; i++)
    {
      var cellElementInnerHTML = LanguageManager.getValueForKey(data[i].displayText);
      var cellElementAttributes = data[i].attributes;
      var cellClasses = options.cellClasses.slice();

      if(data[i].sortable && options.sortable)
      {
        cellElementInnerHTML = createTableHeaderSortCell(data[i]);
        // If sortable --> attributes go on the span with the cell text
        cellElementAttributes = [];
      }

      cellElements += ElementCreator.createStringElement({
        classNames: cellClasses,
        attributes: cellElementAttributes,
        innerHTML: cellElementInnerHTML
      });
    }

    var row = ElementCreator.createStringElement({
      classNames: options.rowClasses,
      innerHTML: cellElements
    });

    return row;
  };

  function createTableHeaderSortCell(data)
  {
    data.sortAttributes = utils.isArray(data.sortAttributes) ? data.sortAttributes : [];

    // Will be overridden if data-sort-property is set in the headers json file
    // Why? order.created returns the date formatted as a string but we want _created so that we get the moment object
    data.sortAttributes.push({
      name: "data-sort",
      value: data.key
    });

    var sortLinkText = ElementCreator.createStringElement({
      tagName: "span",
      attributes: data.attributes,
      innerHTML: LanguageManager.getValueForKey(data.displayText)
    });

    var sortLinkIcons = ElementCreator.createStringElement({
      tagName: "span",
      classNames: [ "sort-icons" ]
    });

    var sortLink = ElementCreator.createStringElement({
      tagName: "span",
      classNames: [ "sort-link" ],
      attributes: data.sortAttributes,
      innerHTML: sortLinkText + sortLinkIcons
    });

    return sortLink;
  }

  Template.createTokenRow = function(headerKeys, data, options)
  {
    options = utils.isNotNull(options) ? options : {};
    options.cellClass = utils.isNotNull(options.cellClass) ? options.cellClass : "fo-cell";
    options.rowClass = utils.isNotNull(options.rowClass) ? options.rowClass : "fo-row";

    options.cellClasses = [ options.cellClass ];

    if(utils.isNotNull(options.rowIdProperty) && !data.hasOwnProperty(options.rowIdProperty))
    {
      return "";
    }

    var cellElements = "";

    for(var j = 0; j < headerKeys.length; j++)
    {
      switch(headerKeys[j])
      {
        case "deactivate-action":
          cellElements += makeDeactivateCell(options);
          break;
        default:
          // Getters do not count for hasOwnProperty ...
          // if(data.hasOwnProperty(headerKeys[j]))
          if(utils.isNotNull(data[headerKeys[j]]))
          {
            cellElements += makeDefaultTableCell(data[headerKeys[j]], options);
          }
          break;
      }
    }

    var attributes = [];

    if(utils.isNotNull(options.rowIdProperty))
    {
      attributes.push({
        "name": "data-row-" + options.rowIdProperty,
        "value": data[options.rowIdProperty]
      });
    }

    var row = ElementCreator.createStringElement({
      tagName: "div",
      classNames: [ options.rowClass ],
      attributes: attributes,
      innerHTML: cellElements
    });

    return row;
  };

  function makeDefaultTableCell(cellValue, options)
  {
    return ElementCreator.createStringElement({
      tagName: "div",
      classNames: options.cellClasses,
      innerHTML: cellValue
    });
  }

  function makeDeactivateCell(options)
  {
    var deactivateBtn = ElementCreator.createStringElement({
      tagName: "button",
      classNames: [ "btn", "btn-icon", "frameless", "trash-o", "dark-grey", "deactivate-subscription-guest-btn" ],
      attributes: [
        { name: "type", value: "button" }
      ]
    });

    options.cellClasses.push("text-right");

    return ElementCreator.createStringElement({
      tagName: "div",
      classNames: options.cellClasses,
      innerHTML: deactivateBtn
    });
  }
}(template));

module.exports = template;



// WEBPACK FOOTER //
// ./app/js/templates/subscription-guest-table-row.template.js